const declaracao_de_transferencia = [
  {
    path: "/declaracao-de-transferencia",
    redirect: "/declaracao_de_transferencia",
    meta: {
      breadCrumb: "Gestão - Emissão de Documentos",
    },
    children: [
      {
        path: "/declaracao-de-transferencia",
        name: "declaracao_de_transferencia",
        component: () =>
          import(
            "@/views/DeclaracaoDeTransferencia/DeclaracaoDeTransferencia.vue"
          ),
      },
    ],
  },
];

export { declaracao_de_transferencia };
